<div class="dialog-container">
    <i class="fa-solid fa-xmark" (click)="onClose.emit()"></i>
    <div class="dialog-title" translate>texts.Tutor_Availability_Dialog_Title</div>
    <div class="dialog-text" translate>texts.Tutor_Availability_Dialog_Description</div>
    <div class="calendar-wrapper">
        <app-general-availability-calendar [hideTitleAndDescription]="true" [isTogglesHidden]="true"></app-general-availability-calendar>
    </div>
    <button class="tutor-cta-button blue-button" type="button" (click)="onConfirm.emit()" translate>
        texts.Tutor_Availability_Dialog_Button
    </button>
</div>
